import type { AnswerSetStatusDto } from "@/models/dto/answerSetStatusDto";
import type { QuestionnaireFormDto } from "@/models/dto/questionnaireItemSetDto";
import { QuestionnaireTemplateInfoDto } from "@/models/dto/questionnaireTemplateInfoDto";
import type { QuestionnaireLanguage } from "@/models/enum/questionnaireLanguage";
import type { Questionnaire } from "@/models/questionnaire";
import type { ForwardedQuestionnaireDto } from "@/models/dto/forwardedQuestionnaire";
import axios from "axios";

export const createQuestionnaire = async (
  templateId: string | null,
  templateLabel: string
): Promise<void> => {
  const dto = new QuestionnaireTemplateInfoDto();
  dto.label = templateLabel;
  dto.id = templateId ?? "";

  await axios.post<Questionnaire>("/api/questionnaire/template", dto);
};

export const getQuestionnaireForm = async (
  contextId: string,
  language: QuestionnaireLanguage
): Promise<QuestionnaireFormDto> => {
  const resp = await axios.get<QuestionnaireFormDto>(
    "/api/questionnaire/form",
    { params: { contextId, language } }
  );
  return resp.data;
};

export const getAnswerStatus = async (
  questionnaireId: string
): Promise<AnswerSetStatusDto[]> => {
  const resp = await axios.get<AnswerSetStatusDto[]>(
    "/api/questionnaire/answers-status",
    { params: { questionnaireId } }
  );
  return resp.data;
};

export const updateQuestionnaire = async (
  questionnaire: Questionnaire
): Promise<Questionnaire> => {
  const resp = await axios.put("/api/questionnaire", questionnaire);
  return resp.data;
};

export const getForwardedQuestionnaires = async (
  questionnaireId: string,
  trustGroupId: string
): Promise<ForwardedQuestionnaireDto[]> => {
  const resp = await axios.get<ForwardedQuestionnaireDto[]>(
    "/api/questionnaire/forwarded-questionnaires",
    { params: { questionnaireId, trustGroupId } }
  );
  return resp.data;
};